import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../web.common';
import AriaModal from 'react-aria-modal';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayGuid
} from '../items';
import { DetailsRightBar, NoLink, Link, Divider, Action } from './DetailsRightBar';
import { weekdaysReverse } from '../../enums/weekdays';
import { COPENHAGEN_TIME_NOTE, formatCopenhagen, formatCourtTime } from '../../common/copenhagenTime';

class SeasonalCourtInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courtData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { seasonalCourtId } } } = this.props;
    const { api: { seasonalcourts: { getCourtWithDetails } } } = this.props;

    try {
      const courtWithDetails = await getCourtWithDetails(seasonalCourtId);
      this.setState({  courtWithDetails });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { seasonalCourtId } }, history } = this.props;
    const { courtWithDetails, errorMessage, isConfirming } = this.state;
    const { api: { seasonalcourts: { getCourtWithDetails, reserveFromPurchase } } } = this.props;
    let mappedData = null;
    let slots = null;
    let purchaseSearchLink = '';
    
    if (courtWithDetails) {
      const {
        Id,
        CreatedAt,
        CourtName,
        FacilityId,
        MembershipId,
        ProductId,
        Status,
        WeekDay,
        Time,
        SeasonStart,
        SeasonEnd,
        Slots
      } = courtWithDetails;

      slots = Slots
        .map(slot => ({ slot, start: new Date(slot.Start)}))
        .sort(({start: start1}, { start: start2}) => (start1 > start2 ? 1 : -1))
        .map(({slot}) => slot);

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        CourtName,
        FacilityId: <DisplayGuid baseAnchor='/facility'>{FacilityId}</DisplayGuid>,
        MembershipId: <DisplayGuid baseAnchor='/product'>{MembershipId}</DisplayGuid>,
        ProductId: <DisplayGuid baseAnchor='/product'>{ProductId}</DisplayGuid>,
        Status,
        WeekDay: weekdaysReverse[WeekDay],
        'Time (Copenhagen)': formatCourtTime(Time),
        'Time Window': `${formatCopenhagen(SeasonStart, { dateOnly: true })} - ${formatCopenhagen(SeasonEnd, { dateOnly: true })}`,
        'Created At': formatCopenhagen(CreatedAt)
      };

      purchaseSearchLink = mappedData ? `/seasonalcourtpurchases?seasonalCourtId=${Id}` : '';
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            {
              isConfirming ? (
                // TODO: extract modal
                <AriaModal
                  titleText='Edit Field'
                  mounted
                  verticallyCenter={false}
                  focusDialog
                  getApplicationNode={() => document.getElementById('app')}
                  dialogClass='dialog-size-normal'
                  scrollDisabled
                >
                  <h3>
                    Are you sure you want to 
                    {' '} {isConfirming}
                    ?
                  </h3>

                  <ButtonOBSOLETED
                    buttonColor='danger'
                    size='small'
                    onClick={async () => {
                      this.setState({
                        isConfirming: false,
                        courtData: null
                      });

                      try {
                        switch (isConfirming) {
                          case 'reserve':
                            const purchaseId = prompt('Enter the purchase id (the membership purchase from the Purchases page, not a seasonal court purchase id)');
                            await reserveFromPurchase(courtWithDetails.Id, purchaseId);
                            break;
                          default: alert('unexpected error: action not found');
                        }
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to ${isConfirming} slot: ${e}`)
                        });
                      }

                      try {
                        const courtWithDetails = await getCourtWithDetails(seasonalCourtId);
                        this.setState({ courtWithDetails });
                      }
                      catch (e) {
                        this.setState({ errorMessage: new Message('error', 'Unable to get data') });
                      }

                      this.setState({
                        isConfirming: false
                      });
                    }}
                    disabled={false}
                    buttonContent={`${isConfirming}`}
                    ariaLabel={`${isConfirming}`}
                  >
                    Proceed
                  </ButtonOBSOLETED>
                  <br />
                  <ButtonOBSOLETED
                    buttonColor='gray'
                    size='small'
                    onClick={() => {
                      this.setState({ isConfirming: false });
                    }}
                    disabled={false}
                    buttonContent='Back'
                    ariaLabel='return'
                  >
                    Back
                  </ButtonOBSOLETED>
                </AriaModal>
              ) : ''
            }

            <div className='content-with-right-pane-delimiter' key={JSON.stringify(courtWithDetails)}>
              <PageTop
                documentTitle='SeasonalCourt details'
                documentDescription='SeasonalCourt details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                SeasonalCourts
              </h2>
              <h5 className='main-page-subheader'>{seasonalCourtId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                    <p style={{ marginTop: '100px' }}><i>{COPENHAGEN_TIME_NOTE}</i></p>
                    <DataTable
                      loadingContent={(<Loader hasLoaded={false} />)}
                      tableConfig={{
                        tableName: 'seasonal-court-slots',
                        rowClasses: 'hover-listview',
                        rowClick: ({ Id }) => {
                          history.push(`/seasonalcourtslot/${Id}`);
                        },
                        columns: [
                          {
                            property: 'Id',
                            label: 'Id'
                          },
                          {
                            property: 'Start',
                            label: 'Start (Copenhagen)',
                            render: ({ Start }) => formatCopenhagen(Start, { fallback: '' })
                          },
                          {
                            property: 'Status',
                            label: 'Status'
                          },
                          {
                            property: 'Purchased',
                            label: 'Purchased',
                            render: ({ Purchased }) => Purchased ? 'yes' : 'no'
                          },
                          {
                            property: 'Reference',
                            label: 'Reference',
                            render: ({ ExternalReferences }) => ExternalReferences ? ExternalReferences.join(',') : ''
                          }]
                      }}
                      getData={async () => slots}
                      paginationData={{
                        renderLocation: 'none',
                        rowsPerPage: 100,
                        pageNumber: 1,
                        goToPageNumber: number => this.goToPage(number)
                      }}
                      skipTableNoResults
                      cellVerticalAlign='top'
                      hideTableHead={false}
                      languageCode='en'
                      labels={{
                        tableBody: {
                          noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                        }
                      }}
                      cellContent='cellContent'
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              {
                purchaseSearchLink ?  
                <Link to={purchaseSearchLink}>Purchases</Link> :
                ''
              }
              <Divider>Actions</Divider>
              <Action action={() => {
                this.setState({ isConfirming: 'reserve' });
              }}
              >
                Reserve
              </Action>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const SeasonalCourt = withRouter(withApi(connect(({ user }) =>
  ({ isLoggedIn: !!user }), {})(SeasonalCourtInternal)));

SeasonalCourt.requiresLogin = true;
SeasonalCourt.propTypes = { isLoggedIn: PropTypes.bool };

export default SeasonalCourt;